module.exports = __webpack_public_path__ + "img/二维码.508a4cd2.gif";